import type { ComponentType } from "react";
import type { ErrorBoundaryProps } from "react-native-error-boundary";
import ReactNativeErrorBoundaryModule from "react-native-error-boundary";

export * from "react-native-error-boundary";
export type { ErrorBoundaryProps, FallbackComponentProps } from "react-native-error-boundary";

type ErrorBoundaryComponent = ComponentType<ErrorBoundaryProps>;
type ErrorBoundaryModule = ErrorBoundaryComponent | { default: ErrorBoundaryComponent };

const errorBoundaryModule = ReactNativeErrorBoundaryModule as ErrorBoundaryModule;

export const ReactNativeErrorBoundary =
  typeof errorBoundaryModule === "object" &&
  errorBoundaryModule !== null &&
  "default" in errorBoundaryModule
    ? errorBoundaryModule.default
    : (errorBoundaryModule as ErrorBoundaryComponent);
